import { Radio } from '@mui/material';
import { styled } from '../../stitches.config';

export const MuiBrandRadio = styled(Radio, {
  '&.Mui-checked': {
    color: '$brand9 !important',
  },
});
